




































































































































































import 'bootstrap';
import bootbox from 'bootbox';
import _ from 'underscore';
import { sprintf } from 'sprintf-js';
import {Component, Vue} from 'vue-property-decorator';
import binaryDownload from '@/services/BinaryDownloader';
import Document from '@/classes/Document';
import DocumentCategory from '@/classes/DocumentCategory';
import { dateFormatter } from '@/services/inputTools';

enum FILE_SIZE { B, KB, MB, GB }

interface Modal extends Element {
    hide(): void;
}

interface DocumentSearchFilters {
    title: string;
    uploadedBy: string;
    sharedWith: string;
    category: string;
}

@Component({
    filters: {
        dateFormatter,

        fileSize(value: number): string {

            if (null == value) {
                return '';
            }

            let i = 0;
            let newValue = value;

            while (newValue > 1024) {
                newValue /= 1024;
                i++;
            }

            return sprintf('%.2f%s', newValue, FILE_SIZE[i]);
        }
    }
})
export default class DocumentSearch extends Vue {

    private filter: DocumentSearchFilters = {
        title: '',
        uploadedBy: '',
        sharedWith: 'any',
        category: 'any'
    };


    private addNewCategoryVisible: boolean = false;
    private newCategory: string | null = null;

    get selectedDocument(): Document {
        return this.$store.getters['documents/selectedDocument']  || {
            file: null,
            title: '',
            description: '',
            category: '',
            sharedWith: [],
            editTitle: '',
            editDescription: '',
            editCategory: '',
            editSharedWith: []
        } as Document;
    }

    get validFile() {
        return undefined !== this.selectedDocument.data;
    }

    get validTitle() {
        return !_.isEmpty(this.selectedDocument.title);
    }

    get validDescription() {
        return !_.isEmpty(this.selectedDocument.description);
    }

    get validCategory() {
        return !_.isEmpty(this.selectedDocument.category);
    }

    get validNewCategory() {
        return !_.isEmpty(this.newCategory);
    }

    get validSharedWith() {
        return !_.isEmpty(this.selectedDocument.sharedWith);
    }

    get validUpload() {
        return this.validFile && this.validTitle && this.validDescription && this.validCategory && this.validSharedWith;
    }

    get categories() {
        return this.$store.getters['documentCategories/categories'];
    }

    private currentDownloads: number[] = [];
    private currentEdits: number[] = [];

    get fields() {
        return [{
            key: 'title',
            label: 'Title',
            sortable: true
        }, {
            key: 'description',
            label: 'Description'
        }, {
            key: 'size',
            label: 'Size',
            sortable: true
        }, {
            key: 'uploaded',
            label: 'Uploaded On',
            sortable: true
        }, {
            key: 'uploadedBy',
            label: 'Uploaded By',
            sortable: true
        }, {
            key: 'sharedWith',
            label: 'Shared With',
            sortable: true
        }, {
            key: 'category',
            label: 'Category',
            sortable: true
        }, {
            key: 'icons',
            label: ''
        }];
    }

    get documents() {
        return _.chain(this.$store.getters['documents/documents'] as Document[])
            .filter((d: Document) => {
                return !!d.title.match(new RegExp(this.filter.title.trim(), 'i'));
            })
            .filter((d: Document) => {
                return !!(d.uploadedBy || '').match(new RegExp(this.filter.uploadedBy.trim(), 'i'));
            })
            .filter((d: Document) => {

                return 'any' === this.filter.sharedWith || _.any(d.sharedWith, (sl: string) => {
                    return sl === this.filter.sharedWith;
                });
            })
            .filter((d: Document) => {
                return 'any' === this.filter.category || d.category.toLowerCase() === this.filter.category.toLowerCase();
            })
            .value();
    }

    private editFile(id: number, show: boolean) {

        const document = _.find(this.documents, (d: Document) => {
            return d.id === id;
        });

        if (null === document || undefined === document) {
            return;
        }

        if (show) {
            document.editTitle = document.title;
            document.editDescription = document.description;
            document.editSharedWith = document.sharedWith;
            document.editCategory = document.category;
            this.currentEdits.push(id);
        } else {
            this.currentEdits = _.without(this.currentEdits, id);
        }
    }

    private saveEditFile(id: number) {

        const document = _.find(this.documents, (d: Document) => {
            return d.id === id;
        });

        if (!document) {
            return;
        }

        const docToSave = {
            id,
            title: document.editTitle,
            description: document.editDescription,
            sharedWith: document.editSharedWith,
            category: document.editCategory
        } as Document;


        this.$store.dispatch('documents/saveDocument', docToSave)
            .then((response) => {
                this.editFile(id, false);
            })
            .catch((err) => {
                bootbox.alert('Failed to save.');
            });
    }

    private deleteFile(id: number) {

        const doc = _.find(this.documents, (d: Document) => {
            return id === d.id;
        });

        const title = !doc ? 'this file' : sprintf('<strong>%s</strong>', doc.title);


        bootbox.confirm(sprintf('Are you sure you want to delete %s?', title), (confirmed: boolean) => {
            if (confirmed) {
                this.$store.dispatch('documents/deleteDocument', id);
            }
        });
    }

    private downloadFile(id: number) {

        this.currentDownloads.push(id);

        binaryDownload('GET', '/api/v1/documents/download/' + id).then(() => {
            const idx = this.currentDownloads.indexOf(id);
            this.currentDownloads.splice(idx, 1);
        }).catch((err) => {
            bootbox.alert(err);
        });
    }

    private onModalShown(): void {
        this.$store.dispatch('documents/selectDocument', {
            title: '',
            description: '',
            sharedWith: [] as string[],
            category: '',
            editTitle: '',
            editDescription: '',
            editCategory: ''
        } as Document);
    }

    private onModalHidden(): void {
        this.$store.dispatch('documents/selectDocument', null);
        this.toggleAddNewCategory(false);
        this.newCategory = null;
    }

    private toggleAddNewCategory(shown: boolean): void {
        this.addNewCategoryVisible = shown;
    }

    private addNewCategory(): void {

        if (!this.validNewCategory) {
            return;
        }

        this.$store.dispatch('documentCategories/addCategory', {category: this.newCategory});

        const selectedCategory = _.find(this.categories, (c: DocumentCategory) => {

            if (null === this.newCategory) {
                return false;
            }

            return c.category.toLowerCase() === this.newCategory.toLowerCase();
        });

        if (selectedCategory) {
            this.selectedDocument.category = selectedCategory.category;
        }

        this.newCategory = null;
        this.toggleAddNewCategory(false);
    }

    private uploadDocument() {

        const selectedDoc = this.$store.getters['documents/selectedDocument'] as Document;

        if (null === selectedDoc || !this.validUpload) {
            return;
        }

        this.$store.dispatch('documents/addNewDocument', selectedDoc)
                .then((response) => {
                    this.closeModal();
                    this.$store.dispatch('documentCategories/loadCategories');
                })
                .catch((err) => {
                    // TODO: Handle error
               });
    }

    private cancelUploadDocument() {
        this.$store.dispatch('documentCategories/pruneCategory', {category: this.selectedDocument.category});
        this.closeModal();
    }

    private closeModal(): void {
        (this.$refs.uploadModalRef as Modal).hide();
    }

    // TODO: make this less insane...
    private formatSharedWith(sharedWith: string[]): string {

        return _.chain(sharedWith)
            .map((sw: string) => {
                switch (sw) {
                    case 'DIRECTOR': return 'Director';
                    case 'INSTRUCTOR': return 'Instructor';
                    case 'FIELD_COORDINATOR': return 'Field Coordinator';
                    case 'GENERAL_OFFICE': return 'General Office';
                    default: return '';
                }
            }).value().join('<br/>');
    }
}
